import { InputGroup as e, inputGroupAddonVariants as t, inputGroupVariants as n } from "../input/input-group.js";
import { forwardRef as r } from "react";
import { jsx as i } from "react/jsx-runtime";
//#region src/select/select-group.tsx
var a = n, o = t, s = r((t, n) => /* @__PURE__ */ i(e.Root, {
	ref: n,
	...t
}));
s.displayName = "SelectGroup.Root";
var c = r(({ ...t }, n) => /* @__PURE__ */ i(e.Addon, {
	ref: n,
	...t
}));
c.displayName = "SelectGroup.Addon";
var l = r((t, n) => /* @__PURE__ */ i(e.Text, {
	ref: n,
	...t
}));
l.displayName = "SelectGroup.Text";
var u = {
	Root: s,
	Addon: c,
	Text: l
};
//#endregion
export { u as SelectGroup, o as selectGroupAddonVariants, a as selectGroupVariants };
